import React, { useState, useRef, useEffect, useCallback } from "react";
import { DatePicker, Space } from 'antd';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { PieChart, Pie, Cell } from "recharts";
import submissionrateImages from "../../assests/images/submissionrate.png";
import averagebidsImages from "../../assests/images/average.png";
import cycletimeImages from "../../assests/images/cycletime.png";
import rejectionrateImages from "../../assests/images/rejectionrate.png";
import savingsImages from "../../assests/images/saving.png";
import participationImages from "../../assests/images/participation.png";
import evaluationImages from "../../assests/images/evaluationtime.png";
import variancebidImages from "../../assests/images/variancebid.png";
import feedbackImages from "../../assests/images/feedbackscro.png";
import rattingupImages from "../../assests/images/Rattingup (2).png";
import rattingdownImages from "../../assests/images/Rattingdown (2).png";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,BarChart,Bar,Rectangle } from 'recharts';
import TableListingWithoutDnD from "../common/tableListingWithoutDnD";
import { rfqServices } from "../../services/rfqServices";
import { useNavigate } from "react-router-dom";
import CustomSearchDropdown from "../common/customSearchDropdown";
import { adminServices } from "../../services/adminServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import _ from "lodash";
import { isEmptyDash, toFixedNum } from "../../constant";

const initialColumns = [
  { id: "index", label: "S.No.", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT"},
  { id: "rfqNumber", label: "RFQ No.", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT"},
  { id: "projectName", label: "Project Name", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "packageName", label: "Package Name", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "qty", label: "QTY", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "bidType", label: "Bid Type", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "vendorsInvited", label: "Invited Vendors", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "vendorsResponded", label: "Responded Vendors", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "finalStatus", label: "Final Status", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "rfqValidity.from", label: "RFQ Validity From Date", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" },
  { id: "rfqValidity.to", label: "RFQ Validity To Date", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" },
  // { id: "error", label: "Error Msg (If failed)", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "col10", label: "Actions", isSort: false, sortLabel: "", formate: "Redirect_Btn", redirectUrl:"/admin/Buyer-Bidding-Rfq-Creaction-Form", redirectKeyName: "_id" },
];


const kpiDataInit = [
  {
    percentage: "75",
    days:"%",
    kpiName: "Submission Rate",
    ratingImage: rattingupImages,
    ratingPercentage:"0%",
    month: "This Month",
    value: "",
    unit:"",
    key: "submissionRate",
    vendorImage:submissionrateImages,
  },
  {
    percentage: "5",
    days:"",
    kpiName: "Average Bids",
    ratingImage: rattingupImages,
    ratingPercentage:"0%",
    month: "This Month",
    value: "",
    unit:"",
    key: "totalBidsEvaluated",
    vendorImage:averagebidsImages,
  },
  {
    percentage: "30",
    days:"Days",
    kpiName: "Average Cycle Time",
    ratingImage: rattingdownImages,
    ratingPercentageone:"0%",
    month: "This Month",
    value: "",
    unit:"",
    key: "averageCycleTime",
    vendorImage:cycletimeImages,
  },
  {
    percentage: "20",
    days:"%",
    kpiName: "Rejection Rate",
    ratingImage: rattingdownImages,
    ratingPercentageone:"0%",
    month: "This Month",
    value: "",
    unit:"",
    key: "rejectionRate",
    vendorImage:rejectionrateImages,
  },
  
]
const kpiData1Init = [
  {
    percentage: "80",
    days:"%",
    kpiName: "Participation Rate",
    ratingImage: rattingupImages,
    ratingPercentage:"0%",
    month: "This Month",
    value: "",
    unit:"",
    key: "participationRate",
    vendorImage:participationImages,
  },
  {
    percentage: "10",
    days:"Days",
    kpiName: "Average Evaluation Time",
    ratingImage: rattingupImages,
    ratingPercentage:"0%",
    month: "This Month",
    value: "",
    unit:"",
    key: "averageEvaluationTime",
    vendorImage:evaluationImages,
  },
  {
    percentage: "50000",
    days:"",
    kpiName: "Bid Variance",
    ratingImage: rattingupImages,
    ratingPercentage:"0%",
    month: "This Month",
    value: "",
    unit:"",
    key: "overallVariance",
    vendorImage:variancebidImages,
  },
  // {
  //   percentage: "45",
  //   days:"%",
  //   kpiName: "Feedback Score",
  //   ratingImage: rattingupImages,
  //   ratingPercentage:"19%",
  //   month: "This Month",
  //   value: "",
  //   unit:"",
  //   key: "sdfsd",
  //   vendorImage:feedbackImages,
  // },
  // {
  //   percentage: "15",
  //   days:"%",
  //   kpiName: "Savings Percentage",
  //   ratingImage: rattingupImages,
  //   ratingPercentage:"19%",
  //   month: "This Month",
  //   value: "",
  //   unit:"",
  //   key: "sdf",
  //   vendorImage:savingsImages,
  // },
  
]
const chartdata1Init = [
  { name: 'Jan', TotalVendorsInvited: 0, SubmissionRate: 0, BidsSubmitted: 0 },
  { name: 'Feb', TotalVendorsInvited: 0, SubmissionRate: 0, BidsSubmitted: 0 },
  { name: 'Mar', TotalVendorsInvited: 0, SubmissionRate: 0, BidsSubmitted: 0 },
  { name: 'Apr', TotalVendorsInvited: 0, SubmissionRate: 0, BidsSubmitted: 0 },
  { name: 'May', TotalVendorsInvited: 0, SubmissionRate: 0, BidsSubmitted: 0 },
  { name: 'Jun', TotalVendorsInvited: 0, SubmissionRate: 0, BidsSubmitted: 0 },
  { name: 'Jul', TotalVendorsInvited: 0, SubmissionRate: 0, BidsSubmitted: 0 },
  { name: 'Aug', TotalVendorsInvited: 0, SubmissionRate: 0, BidsSubmitted: 0 },
  { name: 'Sep', TotalVendorsInvited: 0, SubmissionRate: 0, BidsSubmitted: 0 },
  { name: 'Oct', TotalVendorsInvited: 0, SubmissionRate: 0, BidsSubmitted: 0 },
  { name: 'Nov', TotalVendorsInvited: 0, SubmissionRate: 0, BidsSubmitted: 0 },
  { name: 'Dec', TotalVendorsInvited: 0, SubmissionRate: 0, BidsSubmitted: 0 },
];
const rfxdataInit = [
  { name: 'Jan', TotalBidsReceived: 0, AverageBids: 0, amt: 0 },
  { name: 'Feb', TotalBidsReceived: 0, AverageBids: 0, amt: 0 },
  { name: 'Mar', TotalBidsReceived: 0, AverageBids: 0, amt: 0 },
  { name: 'Apr', TotalBidsReceived: 0, AverageBids: 0, amt: 0 },
  { name: 'May', TotalBidsReceived: 0, AverageBids: 0, amt: 0 },
  { name: 'Jun', TotalBidsReceived: 0, AverageBids: 0, amt: 0 },
  { name: 'Jul', TotalBidsReceived: 0, AverageBids: 0, amt: 0 },
  { name: 'Aug', TotalBidsReceived: 0, AverageBids: 0, amt: 0 },
  { name: 'Sep', TotalBidsReceived: 0, AverageBids: 0, amt: 0 },
  { name: 'Oct', TotalBidsReceived: 0, AverageBids: 0, amt: 0 },
  { name: 'Nov', TotalBidsReceived: 0, AverageBids: 0, amt: 0 },
  { name: 'Dec', TotalBidsReceived: 0, AverageBids: 0, amt: 0 },
];
const rfxCycleTimeInit = [
  { name: 'Jan', MinCycleTime: 0, AverageCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Feb', MinCycleTime: 0, AverageCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Mar', MinCycleTime: 0, AverageCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Apr', MinCycleTime: 0, AverageCycleTime: 0, MaxCycleTime: 0 },
  { name: 'May', MinCycleTime: 0, AverageCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Jun', MinCycleTime: 0, AverageCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Jul', MinCycleTime: 0, AverageCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Aug', MinCycleTime: 0, AverageCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Sep', MinCycleTime: 0, AverageCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Oct', MinCycleTime: 0, AverageCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Nov', MinCycleTime: 0, AverageCycleTime: 0, MaxCycleTime: 0 },
  { name: 'Dec', MinCycleTime: 0, AverageCycleTime: 0, MaxCycleTime: 0 },
];
const bidrejectiondataInit = [
  { name: 'Jan', TotalBidsSubmitted: 0, RejectionRate: 0, BidsRejected: 0 },
  { name: 'Feb', TotalBidsSubmitted: 0, RejectionRate: 0, BidsRejected: 0 },
  { name: 'Mar', TotalBidsSubmitted: 0, RejectionRate: 0, BidsRejected: 0 },
  { name: 'Apr', TotalBidsSubmitted: 0, RejectionRate: 0, BidsRejected: 0 },
  { name: 'May', TotalBidsSubmitted: 0, RejectionRate: 0, BidsRejected: 0 },
  { name: 'Jun', TotalBidsSubmitted: 0, RejectionRate: 0, BidsRejected: 0 },
  { name: 'Jul', TotalBidsSubmitted: 0, RejectionRate: 0, BidsRejected: 0 },
  { name: 'Aug', TotalBidsSubmitted: 0, RejectionRate: 0, BidsRejected: 0 },
  { name: 'Sep', TotalBidsSubmitted: 0, RejectionRate: 0, BidsRejected: 0 },
  { name: 'Oct', TotalBidsSubmitted: 0, RejectionRate: 0, BidsRejected: 0 },
  { name: 'Nov', TotalBidsSubmitted: 0, RejectionRate: 0, BidsRejected: 0 },
  { name: 'Dec', TotalBidsSubmitted: 0, RejectionRate: 0, BidsRejected: 0 },
];
const submitdocumentdata = [
  { name: 'Jan', FinalAwardedBid: 4, InitialEstimatedCost: 24, MinSubmissionTime: 24 },
  { name: 'Feb', FinalAwardedBid: 3, InitialEstimatedCost: 13, MinSubmissionTime: 22 },
  { name: 'Mar', FinalAwardedBid: 2, InitialEstimatedCost: 98, MinSubmissionTime: 22 },
  { name: 'Apr', FinalAwardedBid: 27, InitialEstimatedCost: 39, MinSubmissionTime: 20 },
  { name: 'May', FinalAwardedBid: 18, InitialEstimatedCost: 48, MinSubmissionTime: 21 },
  { name: 'Jun', FinalAwardedBid: 23, InitialEstimatedCost: 38, MinSubmissionTime: 25 },
  { name: 'Jul', FinalAwardedBid: 34, InitialEstimatedCost: 43, MinSubmissionTime: 21 },
  { name: 'Aug', FinalAwardedBid: 23, InitialEstimatedCost: 38, MinSubmissionTime: 25 },
];
const participationratedataInit = [
  { name: 'Jan', VendorsEngaged: 0, TotalVendorsInvited: 0, MinSubmissionTime: 0 },
  { name: 'Feb', VendorsEngaged: 0, TotalVendorsInvited: 0, MinSubmissionTime: 0 },
  { name: 'Mar', VendorsEngaged: 0, TotalVendorsInvited: 0, MinSubmissionTime: 0 },
  { name: 'Apr', VendorsEngaged: 0, TotalVendorsInvited: 0, MinSubmissionTime: 0 },
  { name: 'May', VendorsEngaged: 0, TotalVendorsInvited: 0, MinSubmissionTime: 0 },
  { name: 'Jun', VendorsEngaged: 0, TotalVendorsInvited: 0, MinSubmissionTime: 0 },
  { name: 'Jul', VendorsEngaged: 0, TotalVendorsInvited: 0, MinSubmissionTime: 0 },
  { name: 'Aug', VendorsEngaged: 0, TotalVendorsInvited: 0, MinSubmissionTime: 0 },
  { name: 'Sep', VendorsEngaged: 0, TotalVendorsInvited: 0, MinSubmissionTime: 0 },
  { name: 'Oct', VendorsEngaged: 0, TotalVendorsInvited: 0, MinSubmissionTime: 0 },
  { name: 'Nov', VendorsEngaged: 0, TotalVendorsInvited: 0, MinSubmissionTime: 0 },
  { name: 'Dec', VendorsEngaged: 0, TotalVendorsInvited: 0, MinSubmissionTime: 0 },
];
const evaluationtdataInit = [
  { name: 'Jan', MinEvaluationTime: 0, AverageEvaluationTime: 0, MaxEvaluationTime: 0 },
  { name: 'Feb', MinEvaluationTime: 0, AverageEvaluationTime: 0, MaxEvaluationTime: 0 },
  { name: 'Mar', MinEvaluationTime: 0, AverageEvaluationTime: 0, MaxEvaluationTime: 0 },
  { name: 'Apr', MinEvaluationTime: 0, AverageEvaluationTime: 0, MaxEvaluationTime: 0 },
  { name: 'May', MinEvaluationTime: 0, AverageEvaluationTime: 0, MaxEvaluationTime: 0 },
  { name: 'Jun', MinEvaluationTime: 0, AverageEvaluationTime: 0, MaxEvaluationTime: 0 },
  { name: 'Jul', MinEvaluationTime: 0, AverageEvaluationTime: 0, MaxEvaluationTime: 0 },
  { name: 'Aug', MinEvaluationTime: 0, AverageEvaluationTime: 0, MaxEvaluationTime: 0 },
  { name: 'Sep', MinEvaluationTime: 0, AverageEvaluationTime: 0, MaxEvaluationTime: 0 },
  { name: 'Oct', MinEvaluationTime: 0, AverageEvaluationTime: 0, MaxEvaluationTime: 0 },
  { name: 'Nov', MinEvaluationTime: 0, AverageEvaluationTime: 0, MaxEvaluationTime: 0 },
  { name: 'Dec', MinEvaluationTime: 0, AverageEvaluationTime: 0, MaxEvaluationTime: 0 },
];
const vendorfeedbackdata = [
  { name: 'Jan', uv: 4, pv: 24, amt: 24 },
  { name: 'Feb', uv: 3, pv: 13, amt: 22 },
  { name: 'Mar', uv: 2, pv: 98, amt: 22 },
  { name: 'Apr', uv: 27, pv: 39, amt: 20 },
  { name: 'May', uv: 18, pv: 48, amt: 21 },
  { name: 'Jun', uv: 23, pv: 38, amt: 25 },
  { name: 'Jul', uv: 34, pv: 43, amt: 21 },
  { name: 'Aug', uv: 23, pv: 38, amt: 25 },
];
const variancedbidataInit = [
  { name: 'Jan', LowestBidPrice: 0, HighestBidPrice: 0, MinSubmissionTime: 0 },
  { name: 'Feb', LowestBidPrice: 0, HighestBidPrice: 0, MinSubmissionTime: 0 },
  { name: 'Mar', LowestBidPrice: 0, HighestBidPrice: 0, MinSubmissionTime: 0 },
  { name: 'Apr', LowestBidPrice: 0, HighestBidPrice: 0, MinSubmissionTime: 0 },
  { name: 'May', LowestBidPrice: 0, HighestBidPrice: 0, MinSubmissionTime: 0 },
  { name: 'Jun', LowestBidPrice: 0, HighestBidPrice: 0, MinSubmissionTime: 0 },
  { name: 'Jul', LowestBidPrice: 0, HighestBidPrice: 0, MinSubmissionTime: 0 },
  { name: 'Aug', LowestBidPrice: 0, HighestBidPrice: 0, MinSubmissionTime: 0 },
  { name: 'Sep', LowestBidPrice: 0, HighestBidPrice: 0, MinSubmissionTime: 0 },
  { name: 'Oct', LowestBidPrice: 0, HighestBidPrice: 0, MinSubmissionTime: 0 },
  { name: 'Nov', LowestBidPrice: 0, HighestBidPrice: 0, MinSubmissionTime: 0 },
  { name: 'Dec', LowestBidPrice: 0, HighestBidPrice: 0, MinSubmissionTime: 0 },
];

function BiddingPariticiptionDashboardTab(props) {
  
  let navigate = useNavigate();
  const navigateUrl = (param) => {
    navigate(param);
  };
  
  const [selectedObj, setSelectedObj] = useState(null);
  const [newDateRange, setNewDateRange] = useState({ from: "", to: "" });
  const [kpiData, setKPIData] = useState(kpiDataInit);
  const [kpiData1, setKPIData1] = useState(kpiData1Init);

  const [chartdata1, setChartData1] = useState(chartdata1Init);
  const [rfxData, setRfxData] = useState(rfxdataInit);
  const [rfxCycleTime, setRfxCycleTime] = useState(rfxCycleTimeInit);
  const [bidRejectionRate, setBidRejectionRate] = useState(bidrejectiondataInit);
  const [participationratedata, setParticipationratedata] = useState(participationratedataInit);
  const [evaluationtdata, setEvaluationtdata] = useState(evaluationtdataInit);
  const [variancedbidata, setVariancedbidata] = useState(variancedbidataInit);
  
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const [isLoading, setIsLoading] = useState(false);

  const disabledDate = (current) => {
    return current && current < new Date().setHours(0, 0, 0, 0);
  };

  const onSearchSelectChange = (param) => {
    // console.log(param);      
    setSelectedObj(param);
  }

  const getUnit = (data) => {
    if (data.unit == "percentage") {
      return "%";
    }
    return data.unit;
  } 
  

  useEffect(() => {
    getDashboardOBData(""); 
  }, []);
  
  useEffect(() => {
    if (props?.count > 0) {
      // console.log("sdfsdf", props?.count); 
      let str = isEmptyDash(selectedObj?.selectedValue) ? "" : selectedObj?.selectedValue;
      getDashboardOBData(str);
    }     
  }, [props?.count]);

  const getDashboardOBData = (rfqId) => {
    let newDate = new Date();
    let newYear = newDate.getFullYear();
    newDateRange["from"] = `${newYear}-01-01`;
    newDateRange["to"] = `${newYear}-12-31`;
        
    let bodyData = {
      "rfqId": rfqId,
      "dateRange": {
          "startDate": newDateRange?.from,
          "endDate": newDateRange?.to,
      }
    }; 
    // console.log(bodyData); 
    
    setIsLoading(true);
    let promise = adminServices.adminDashboardBidding(bodyData);
    promise.then((res) => {
      if (res.data.success === true) {
        let data = res?.data?.data;
        // let data = dbResObj?.data;
        props?.addNewTime(new Date());

        let chartdataInit1 = _.cloneDeep(chartdata1Init);
        let rfxdataInit1 = _.cloneDeep(rfxdataInit);
        let rfxCycleTimeInit1 = _.cloneDeep(rfxCycleTimeInit);
        let bidrejectiondataInit1 = _.cloneDeep(bidrejectiondataInit);
        let participationratedataInit1 = _.cloneDeep(participationratedataInit);
        let evaluationtdataInit1 = _.cloneDeep(evaluationtdataInit);
        let variancedbidataInit1 = _.cloneDeep(variancedbidataInit);
          
        let kpiDataInit = _.cloneDeep(kpiData);
        let kpiData1Init = _.cloneDeep(kpiData1);

        for (let i = 0; i < kpiDataInit.length; i++) {          
          if (kpiDataInit[i]?.key == "submissionRate" ) {
            kpiDataInit[i].value = data["bidSubmissionRate"]["submissionRate"];
            kpiDataInit[i].unit = getUnit(data["bidSubmissionRate"]);
          }          
          if (kpiDataInit[i]?.key == "totalBidsEvaluated" ) {
            kpiDataInit[i].value = data["averageBidEvaluationTime"]["totalBidsEvaluated"];
            kpiDataInit[i].unit = getUnit(data["averageBidEvaluationTime"]);
          }          
          if (kpiDataInit[i]?.key == "averageCycleTime" ) {
            kpiDataInit[i].value = data["RFXCycleTime"]["averageCycleTime"];
            kpiDataInit[i].unit = getUnit(data["RFXCycleTime"]);
          }          
          if (kpiDataInit[i]?.key == "rejectionRate" ) {
            kpiDataInit[i].value = data["bidRejectionRate"]["rejectionRate"];
            kpiDataInit[i].unit = getUnit(data["bidRejectionRate"]);
          }    
        }
        
        for (let i = 0; i < kpiData1Init.length; i++) {          
          if (kpiData1Init[i]?.key == "participationRate" ) {
            kpiData1Init[i].value = data["vendorParticipationRate"]["participationRate"];
            kpiData1Init[i].unit = getUnit(data["vendorParticipationRate"]);
          }          
          if (kpiData1Init[i]?.key == "averageEvaluationTime" ) {
            kpiData1Init[i].value = toFixedNum(data["averageBidEvaluationTime"]["averageEvaluationTime"]);
            kpiData1Init[i].unit = getUnit(data["averageBidEvaluationTime"]);
          }          
          if (kpiData1Init[i]?.key == "overallVariance" ) {
            kpiData1Init[i].value = toFixedNum(data["bidPriceVariance"]["overallVariance"]);
            kpiData1Init[i].unit = getUnit(data["bidPriceVariance"]);
          }   
        }

        // // For Bid Submission Rate
        for (let j = 0; j < chartdataInit1.length; j++) {
          chartdataInit1[j]["amt"] = 0;
          chartdataInit1[j]["pv"] = 0;
          chartdataInit1[j]["uv"] = 0;
          for (let k = 0; k < data?.bidSubmissionRate?.monthlyData.length; k++) {
            if (j == data?.bidSubmissionRate?.monthlyData[k]?.month - 1) {
              chartdataInit1[j]["amt"] = data?.bidSubmissionRate?.monthlyData[k]?.bidsSubmitted;
              chartdataInit1[j]["pv"] = data?.bidSubmissionRate?.monthlyData[k]?.submissionRate;
              chartdataInit1[j]["uv"] = data?.bidSubmissionRate?.monthlyData[k]?.totalVendorsInvited;              
            }
          }
        }

        // For RFX Data
        for (let j = 0; j < rfxdataInit1.length; j++) {
          rfxdataInit1[j]["AverageBids"] = 0;
          rfxdataInit1[j]["TotalBidsReceived"] = 0;
          rfxdataInit1[j]["amt"] = 0;
          for (let k = 0; k < data?.averageBidsPerRFX?.monthlyData.length; k++) {
            if (j == data?.averageBidsPerRFX?.monthlyData[k]?.month - 1) {
              rfxdataInit1[j]["AverageBids"] = data?.averageBidsPerRFX?.monthlyData[k]?.averageCycleTime;
              rfxdataInit1[j]["TotalBidsReceived"] = data?.averageBidsPerRFX?.monthlyData[k]?.maxCycleTime;
              rfxdataInit1[j]["amt"] = data?.averageBidsPerRFX?.monthlyData[k]?.minCycleTime;              
            }
          }
        }

        // For rfx Cycle Time nit1
        for (let j = 0; j < rfxCycleTimeInit1.length; j++) {
          rfxCycleTimeInit1[j]["AverageCycleTime"] = 0;
          rfxCycleTimeInit1[j]["MaxCycleTime"] = 0;
          rfxCycleTimeInit1[j]["MinCycleTime"] = 0;
          for (let k = 0; k < data?.RFXCycleTime?.monthlyData.length; k++) {
            if (j == data?.RFXCycleTime?.monthlyData[k]?.month - 1) {
              rfxCycleTimeInit1[j]["AverageSubmissionTime"] = data?.RFXCycleTime?.monthlyData[k]?.averageCycleTime;
              rfxCycleTimeInit1[j]["MaxCycleTime"] = data?.RFXCycleTime?.monthlyData[k]?.maxCycleTime;
              rfxCycleTimeInit1[j]["MinCycleTime"] = data?.RFXCycleTime?.monthlyData[k]?.minCycleTime;              
            }
          }
        }

        // For Bid rejection Rate
        for (let j = 0; j < bidrejectiondataInit1.length; j++) {
          bidrejectiondataInit1[j]["amt"] = 0;
          bidrejectiondataInit1[j]["pv"] = 0;
          bidrejectiondataInit1[j]["uv"] = 0;
          for (let k = 0; k < data?.bidRejectionRate?.monthlyData.length; k++) {
            if (j == data?.bidRejectionRate?.monthlyData[k]?.month - 1) {
              bidrejectiondataInit1[j]["amt"] = data?.bidRejectionRate?.monthlyData[k]?.bidsRejected;
              bidrejectiondataInit1[j]["pv"] = data?.bidRejectionRate?.monthlyData[k]?.rejectionRate;
              bidrejectiondataInit1[j]["uv"] = data?.bidRejectionRate?.monthlyData[k]?.totalBidsSubmitted;              
            }
          }
        }

        // For Vendor Drop-off Rate
        for (let j = 0; j < participationratedataInit1.length; j++) {
          participationratedataInit1[j]["MinSubmissionTime"] = 0;
          participationratedataInit1[j]["TotalVendorsInvited"] = 0;
          participationratedataInit1[j]["VendorsEngaged"] = 0;

          for (let k = 0; k < data?.vendorParticipationRate?.monthlyData.length; k++) {
            if (j == data?.vendorParticipationRate?.monthlyData[k]?.month - 1) {
              participationratedataInit1[j]["MinSubmissionTime"] = data?.vendorParticipationRate?.monthlyData[k]?.participationRate;
              participationratedataInit1[j]["TotalVendorsInvited"] = data?.vendorParticipationRate?.monthlyData[k]?.totalVendorsInvited;
              participationratedataInit1[j]["VendorsEngaged"] = data?.vendorParticipationRate?.monthlyData[k]?.vendorsEngaged;              
            }
          }          
        }

        // For Evaluation Data
        for (let j = 0; j < evaluationtdataInit1.length; j++) {
          evaluationtdataInit1[j]["AverageEvaluationTime"] = 0;
          evaluationtdataInit1[j]["MaxEvaluationTime"] = 0;
          evaluationtdataInit1[j]["MinEvaluationTime"] = 0;

          for (let k = 0; k < data?.averageBidEvaluationTime?.monthlyData.length; k++) {
            if (j == data?.averageBidEvaluationTime?.monthlyData[k]?.month - 1) {
              evaluationtdataInit1[j]["AverageEvaluationTime"] = data?.averageBidEvaluationTime?.monthlyData[k]?.averageEvaluationTime;
              evaluationtdataInit1[j]["MaxEvaluationTime"] = data?.averageBidEvaluationTime?.monthlyData[k]?.maxEvaluationTime;
              evaluationtdataInit1[j]["MinEvaluationTime"] = data?.averageBidEvaluationTime?.monthlyData[k]?.minEvaluationTime;              
            }
          }          
        }

        // For Variance Data
        // for (let j = 0; j < variancedbidataInit1.length; j++) {
        //   variancedbidataInit1[j]["HighestBidPrice"] = 0;
        //   variancedbidataInit1[j]["LowestBidPrice"] = 0;
        //   variancedbidataInit1[j]["MinSubmissionTime"] = 0;

        //   for (let k = 0; k < data?.averageBidEvaluationTime?.monthlyData.length; k++) {
        //     if (j == data?.averageBidEvaluationTime?.monthlyData[k]?.month - 1) {
        //       variancedbidataInit1[j]["HighestBidPrice"] = data?.averageBidEvaluationTime?.monthlyData[k]?.averageEvaluationTime;
        //       variancedbidataInit1[j]["LowestBidPrice"] = data?.averageBidEvaluationTime?.monthlyData[k]?.maxEvaluationTime;
        //       variancedbidataInit1[j]["MinSubmissionTime"] = data?.averageBidEvaluationTime?.monthlyData[k]?.minEvaluationTime;              
        //     }
        //   }          
        // }

        // // console.log(data, vendordropoffdataInit1);
        
        setChartData1(chartdataInit1);
        setRfxData(rfxdataInit1);
        setRfxCycleTime(rfxCycleTimeInit1);
        setBidRejectionRate(bidrejectiondataInit1);
        setParticipationratedata(participationratedataInit1);
        setEvaluationtdata(evaluationtdataInit1)

        console.log(kpiDataInit, kpiData1Init);
        
        setKPIData(kpiDataInit);
        setKPIData1(kpiData1Init);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
    .catch(function (error) {
      console.log(error);
      setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
    })
    .finally((param) => {
      setIsLoading(false);
    });
  };
  
  const clearData = (param) => {
    setSelectedObj({selectedLable: "", selectedValue: ""}); 
    getDashboardOBData("");   
  }

  return (

      <div class="login-forms">
        <div class="text-centers">
        <div className="main_row_bidding_vendordonbdasboard">
            
              <div>
                  <div className="required_react_vendor_block_dashboard">
                    <label className="row_div_box_select_dashboard">RFQ ID</label>

                    <div className="dashboard_site_select">
                        <CustomSearchDropdown 
                            // column={initialColumns}
                            listingArrName="rfqs"
                            onSearchSelectChange={onSearchSelectChange}
                            promiseRequest={rfqServices.getRfqListing}
                            // extraPromiseParam="poExists=true"
                            additionalData={{
                              lableKeyName1: "rfqNumber",
                              lableKeyName2: "",
                              valueKeyName: "_id",
                            }} 
                            // isDisable={(details?.assigneeId != UserObj?._id)}  
                            defaultValue={selectedObj}           
                          />                      
                    </div>
                  </div>
                </div>
                
            <div>

            </div>
            <div className="invoicing_dashboard_btns">
              <button type="button" class="btn btn-success save_next_btns" onClick={() => getDashboardOBData(selectedObj?.selectedValue)}>
                Apply
              </button>
              <button type="button" class="btn clear_btn_status_block_lists" style={{marginLeft: "10px"}} onClick={clearData}>
                Clear
              </button>
            </div>
          </div>
          <div className="vendor_dasboard_maine_box_row">
           {
  kpiData.map((kpi,i) => (
    <div key={i} className="bpdt_row1_box11">
      <div className="bpdt_row1_box1_left">
        <div>
          <div className="pad_marg_row">
          <h1 className="noPadMarg percentage_vendor_dashboard_body">{kpi?.value}</h1>
          <span className="days_percentage_name">{kpi?.unit}</span>
          </div>
          <p className="noPadMarg Participated_bpdt_div">
            {kpi.kpiName}
          </p>
        </div>
        <div className="bpdt_row1_box1_left_row2">
          <div className="bpdt_row1_block">
            <img src={kpi.ratingImage} alt="" />
            <p className="rating_color">{kpi.ratingPercentage}</p>
            <p className="rating_color_down">{kpi.ratingPercentageone}</p>
            <p>{kpi.month}</p>
          </div>
        </div>
      </div>
      <div className="avergecyle_imges_body">
        <MoreVertIcon />
        <img src={kpi.vendorImage} alt="" className="avergecyle_imges" />
      </div>
    </div>
  ))
}
  </div>
  <div className="vendor_dasboard_maine_box_row2">
           {
  kpiData1.map((kpi,i) => (
    <div key={i} className="bpdt_row1_box11">
      <div className="bpdt_row1_box1_left">
        <div>
          <div className="pad_marg_row">
          <h1 className="noPadMarg percentage_vendor_dashboard_body">{kpi.value}</h1>
          <span className="days_percentage_name">{kpi.unit}</span>
          </div>
          <p className="noPadMarg Participated_bpdt_div">
            {kpi.kpiName}
          </p>
        </div>
        <div className="bpdt_row1_box1_left_row2">
          <div className="bpdt_row1_block">
            <img src={kpi.ratingImage} alt="" />
            <p className="rating_color">{kpi.ratingPercentage}</p>
            <p className="rating_color_down">{kpi.ratingPercentageone}</p>
            <p>{kpi.month}</p>
          </div>
        </div>
      </div>
      <div className="avergecyle_imges_body">
        <MoreVertIcon />
        <img src={kpi.vendorImage} alt="" className="avergecyle_imges" />
      </div>
    </div>
  ))
}
  </div>
  <div className="vendor_dashboard_secondbody_row">
  <div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Bid Submission Rate</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="100%" height={320}>
      <BarChart className="ResponsiveContainer_vendor_dashboard"
        data={chartdata1}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name"  />
        <YAxis />
        <Tooltip  />
        <Legend  />
        <Bar className="responsive_vendor_dashboard" dataKey="SubmissionRate" fill="#9BBB58" shape={<Rectangle fill="#9BBB58"  />} />
        <Bar className="responsive_vendor_dashboard" dataKey="TotalVendorsInvited" fill="#9BBB58" shape={<Rectangle fill="#9BBB58"  />} />
        <Bar className="responsive_vendor_dashboard" dataKey="BidsSubmitted " fill="#9BBB58" shape={<Rectangle fill="#9BBB58"  />} />
      </BarChart>
    </ResponsiveContainer>
</div>
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Average Number of Bids per RFX</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="100%" height={300}>
        <BarChart className="dashboard_barchart"
          width={500}
          height={300}
          data={rfxData}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          
          <Bar dataKey="AverageBids" stackId="a" fill="#FEC321" />
          <Bar dataKey="TotalBidsReceived" stackId="a" fill="#59E6F6" />
        </BarChart>
      </ResponsiveContainer>
</div>
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">RFX Cycle Time</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="100%" height={300}>
    <BarChart className="dashboard_barchart" data={rfxCycleTime}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="AverageCycleTime" stackId="a" fill="#695EEF" />
        <Bar dataKey="MinCycleTime" stackId="a" fill="#11D1B7" />
        <Bar dataKey="MaxCycleTime" stackId="a" fill="#FFC061" />
    </BarChart>
</ResponsiveContainer>
</div>
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Bid Rejection Rate</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="100%" height={320}>
          <BarChart className="ResponsiveContainer_vendor_dashboard"
          data={bidRejectionRate}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="RejectionRate" stackId="a" fill="#0095F6" />  
          <Bar dataKey="TotalBidsSubmitted" stackId="a" fill="#0095F6" />
          <Bar dataKey="BidsRejected" stackId="a" fill="#0095F6" />
        </BarChart>
      </ResponsiveContainer>
</div>
{/* <div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Cost Savings Through Bidding</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="110%" height={300}>
      <LineChart className="ResponsiveContainer_vendor_dashboard" 
        data={submitdocumentdata}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis yAxisId="left" />
        <YAxis yAxisId="right" orientation="right" />
        <Tooltip />
        <Legend />
        <Line yAxisId="left" type="monotone" dataKey="InitialEstimatedCost" stroke="#59E6F6" activeDot={{ r: 8 }} strokeWidth={3} dot={false} />
        <Line yAxisId="left" type="monotone" dataKey="FinalAwardedBid" stroke="#7661E2" activeDot={{ r: 8 }} strokeWidth={3} dot={false} />
      </LineChart>
    </ResponsiveContainer>
</div> */}
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Vendor Participation Rate</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="110%" height={300}>
      <LineChart className="ResponsiveContainer_vendor_dashboard" 
        data={participationratedata}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis yAxisId="left" />
        <YAxis yAxisId="right" orientation="right" />
        <Tooltip />
        <Legend />
        <Line yAxisId="left" type="monotone" dataKey="TotalVendorsInvited" stroke="#FB896B" activeDot={{ r: 8 }} strokeWidth={3} dot={false} />
        <Line yAxisId="left" type="monotone" dataKey="VendorsEngaged" stroke="#6956E5" activeDot={{ r: 8 }} strokeWidth={3} dot={false} />
      </LineChart>
    </ResponsiveContainer>
</div>
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Average Bid Evaluation Time</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="100%" height={300}>
    <BarChart className="dashboard_barchart" data={evaluationtdata}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="AverageEvaluationTime" stackId="a" fill="#F6866A" />
        <Bar dataKey="MinEvaluationTime" stackId="a" fill="#FABE7A" />
        <Bar dataKey="MaxEvaluationTime" stackId="a" fill="#7661E2" />
    </BarChart>
</ResponsiveContainer>
</div>
{/* <div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Vendor Feedback Score</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="100%" height={320}>
          <BarChart className="ResponsiveContainer_vendor_dashboard"
          data={vendorfeedbackdata}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="pv" stackId="a" fill="#FF9818" />
        </BarChart>
      </ResponsiveContainer>
</div> */}
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Bid Price Variance</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="110%" height={300}>
      <LineChart className="ResponsiveContainer_vendor_dashboard" 
        data={variancedbidata}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis yAxisId="left" />
        <YAxis yAxisId="right" orientation="right" />
        <Tooltip />
        <Legend />
        <Line yAxisId="left" type="monotone" dataKey="HighestBidPrice" stroke="#FFA5CB" activeDot={{ r: 8 }} strokeWidth={3} dot={false} />
        <Line yAxisId="left" type="monotone" dataKey="LowestBidPrice" stroke="#7987FF" activeDot={{ r: 8 }} strokeWidth={3} dot={false} />
      </LineChart>
    </ResponsiveContainer>
</div>
  </div>
          <div className="table_row_dashboard_body_main2">
            <div className="admin_dashboard_row_participation_here">
              <h4 className="text_vendors_dashboard_inpie">All RFQs</h4>
              <div className="admin_dashboard_row_right_table">
                
                <button className="btn_bpdt_view_row_bidding_dash" onClick={() => navigateUrl(`/admin/Engineering-Bidding-Rfq-Listing`)}>
                  View all Bidding
                </button>
              </div>
            </div>
            <div className="listing_main_row_dashboard_bpdt_block">
              <TableListingWithoutDnD
                  column={initialColumns}
                  listingArrName="rfqs"
                  filterKeyName={""}
                  componentName="RFQ_List"
                  promiseRequest={rfqServices.getRfqListing}
                  promiseUrlType="LIST"
                  additionalData={{
                    isMaster: false,
                    type: "RFQ_List",
                    isTrackOrder: false,
                    isFilter: false,
                    isSearch: false,
                    isSort: false,
                    isPagePerSize: false,
                    isPagination: false,
                    isDragable: false,
                  }}
              />
            </div>
            
          </div>
        </div>
        
        <AlertComponent
            alertComponent={alertComponent}
          handleClose={handleCloseAlert}
        />

        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => 999999,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
      
 
  );
}

export default BiddingPariticiptionDashboardTab;
